import { useEffect, useState } from 'react';
import { CustomToolbarBtnProps } from '../types/customToolbarBtnTypes';
import SelectDropdown from '../../SelectDropdown/SelectDropdown';

// Available text level options
const options = [
  'Paragraph',
  'Heading 1',
  'Heading 2',
  'Heading 3',
  'Heading 4',
  'Heading 5',
  'Heading 6',
];

export default function HeadingSelect({ editor, disabled }: CustomToolbarBtnProps) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    // Update selected index when editor text has active heading
    const updateHeading = () => {
      if (editor?.isActive('heading')) {
        const headingLevel = editor?.getAttributes('heading').level;
        setSelectedIndex(headingLevel);
      } else {
        setSelectedIndex(0);
      }
    };

    editor?.on('selectionUpdate', updateHeading);

    return () => {
      editor?.off('selectionUpdate', updateHeading);
    };
  }, [editor]);

  // Handle option selection
  const handleOptionSelect = (index: number) => {
    if (index === 0) {
      const headingLevel = editor?.getAttributes('heading').level;
      editor?.commands.toggleHeading({ level: headingLevel });
    } else if (index <= 6) {
      editor?.commands.setHeading({ level: index as any });
    }
    editor?.commands.focus();
  };

  return (
    <SelectDropdown
      options={options}
      onOptionSelect={handleOptionSelect}
      controlledSelectedIndex={selectedIndex}
      disabled={disabled}
      width="120px"
    />
  );
}
